import React, {useContext, useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import {Container, Box} from '@material-ui/core';
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Alert, AlertTitle} from '@material-ui/lab';
import {useClearForm} from 'components/forms/hooks';
import {FormState} from 'components/forms/context';
import FormNavigation, {
    defaultBack,
    defaultNext,
} from 'components/forms/context/FormNavigation';

const useStyles = makeStyles(theme => ({
    info: {
        color: theme.palette.primary.dark,
        fontWeight: 'bold',
    },
}));

const Errors = ({history}) => {
    const classes = useStyles();
    const {setBackButton, setNextButton} = useContext(FormNavigation);
    const {node, response} = useContext(FormState);
    const clearFormState = useClearForm(node);

    useEffect(() => {
        setBackButton({
            ...defaultBack,
            onClick: () => true,
        });
        setNextButton({
            ...defaultNext,
            label: 'Abort!',
            color: 'secondary',
            testHook: 'form-nav-abort',
            onClick: () => {
                // Clear form state
                clearFormState();
                // Go home
                history.push('/');
                return false;
            },
        });

        return () => {
            setBackButton(defaultBack);
            setNextButton(defaultNext);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container>
            <Typography variant='h6' align='left'>
                Errors
            </Typography>
            <Box component='div' my={2} className={classes.info}>
                <Alert severity='info'>
                    Unfortunately, our system has noticed some errors in your
                    paperwork. They are listed below. MM-SEAS cannot accept
                    documents with errors. If you entered something incorrectly,
                    please go back to correct it. Otherwise, please abort this
                    document, fix the error on your paperwork, and upload a new
                    photo before trying again.
                </Alert>
            </Box>
            <Box component='div' my={2} className={classes.error}>
                <Alert variant='outlined' severity='error'>
                    <AlertTitle>Errors</AlertTitle>
                    <ol style={{paddingInlineStart: 0}}>
                        {response?.errors?.map((error, index) => (
                            <li
                                key={`error-${index}`}
                                style={{marginTop: index === 0 ? 0 : '0.5rem'}}
                            >
                                {error.error_message}
                            </li>
                        ))}
                    </ol>
                </Alert>
            </Box>
        </Container>
    );
};

export default withRouter(Errors);
